import React from 'react';
import { Text } from '@simplybenefits/sb-ui-library';
import { helpers } from '@simplybenefits/sb-utils';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { 
    Add as AddIcon, 
    Remove as RemoveIcon 
} from '@mui/icons-material';

/**
 *
 * @param {*} props
 */
export default function DependentLife({ classes, expanded, dependentLife, handleChange, isStudent }) {
    return (
        <div style={ classes.block }>
            <Accordion
                square
                onChange={handleChange('dependentLife')}
                style={{ boxShadow: 'none' }}
                disableGutters={true}
            >
                <AccordionSummary
                    classes={{
                        content: classes.panelContent,
                        expanded: classes.expanded,
                        root: classes.root
                    }}
                    expandIcon={expanded.includes('dependentLife') ? <RemoveIcon /> : <AddIcon />}
                    sx={classes.accordionSummary}
                >
                    <Text medium bold>Dependent Life</Text>
                </AccordionSummary>
                <AccordionDetails style={classes.panelDetails}>
                    {
                        dependentLife.isEligible !== 1 ? 
                            <div style={classes.row}>
                                <Text small bold margin="20px 0px 10px 0px">
                                    You are currently ineligible for this benefit, if this is a mistake please contact your administrator.
                                </Text>
                            </div>
                            : null
                    }

                    <Text small bold margin="20px 0px 10px 0px">
                        {
                            dependentLife.spouseCoverage ? `You have $${ helpers.formatNumber(dependentLife.spouseCoverage) } for spouse coverage. ` : null
                        }
                        {
                            dependentLife.childCoverage ? `You have $${ helpers.formatNumber(dependentLife.childCoverage) } for child coverage. ` : null
                        }
                    </Text>

                    { 
                        isStudent ?
                            <Text small margin="5px 0px 10px 0px">
                                { `Terminates at age ${ dependentLife.terminationAge } or date of participants study if earlier.` }
                            </Text>
                            :
                            <Text small margin="5px 0px 10px 0px">
                                { `Terminates at age ${ dependentLife.terminationAge } or date of participants retirement if earlier.` }
                            </Text>
                    }
                </AccordionDetails>
            </Accordion>
        </div>
    );
}